import { createContext } from 'react'

import { type Subsidies } from './SubsidiesTypes'


export const defaultSubsidies = {}

type ContentType = {
  subsidies: Subsidies,
  timezone: string,
}

const defaultContent: ContentType = {
  subsidies: defaultSubsidies,
  timezone: 'Europe/Moscow',
}

type LoadingType = {
  subsidies: boolean,
}

const defaultLoading: LoadingType = {
  subsidies: true,
}

type RequestsType = {
  subsidies: () => Promise<void> | void,
}

const defaultRequests = {
  subsidies: () => { },
}

type SubsidiesContextType = {
  content: ContentType,
  loading: LoadingType,
  request: RequestsType,
}

const defaultContext: SubsidiesContextType = {
  content: defaultContent,
  loading: defaultLoading,
  request: defaultRequests,
}

export default createContext<SubsidiesContextType>(defaultContext)
